
import React, { FunctionComponent } from "react"
import sketchyPenSizes from "../Utils/SketchyPenSizes"
import SketchyPenPickerTypes from "../Types/SketchyPenPickerTypes"
import SketchyColorTypes from "../Types/SketchyColorTypes"
import { OverlayTrigger } from "react-bootstrap"
import sketchyTooltip from "../Utils/SketchyTooltip"
import "./SketchyPenPicker.css"

interface Props {
    manageParentState: Function
    pen: SketchyPenPickerTypes
    color: SketchyColorTypes
    isErasing: boolean
}

const SketchyPenPicker: FunctionComponent<Props> = (props) => {

    const { manageParentState, pen, color, isErasing } = props

    return (
        <div className="SketchyPenPicker">
            {sketchyPenSizes.map((p, i) =>
                <OverlayTrigger placement="top" overlay={sketchyTooltip(`${p.name} ${isErasing ? "eraser" : "pen"}`)} key={i}>
                    <div
                        className={`SketchyPenPickerItemOuter ${pen.size === p.size ? "SketchyPenPickerItemOuterChecked" : "SketchyPenPickerItemOuterUnchecked"}`}
                        onClick={() => manageParentState([{ key: "pen", value: p }])}
                    >
                        <div
                            className="SketchyPenPickerItemInner"
                            style={{ width: `${p.size}px`, height: `${p.size}px`, backgroundColor: `${isErasing ? "unset" : color.hc}` }}
                        >
                        </div>
                    </div>
                </OverlayTrigger>
            )}
        </div>
    )
}

export default SketchyPenPicker